import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "../../utils";
import { queryKeys } from "../queryKeys";
import { useToast } from "@chakra-ui/react";
import { AxiosError } from "axios";

export function useWageImportJobsDelete() {
    const axios = axiosInstance(),
        queryClient = useQueryClient();

    const toast = useToast();

    return useMutation({
        mutationFn: (request: { tenantId: string | undefined; jobId: string }) => axios.delete(`api/clients/${request.tenantId}/wagejobs/${request.jobId}`),
        onSuccess: async (data, variables) => {
            await queryClient.invalidateQueries(queryKeys.wageImportJobs.byTenantId(variables.tenantId ?? "").queryKey);

            toast({
                title: "Deletion Successful",
                description: "Wage Import Job was deleted.",
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        },
        onError: error => {
            const axiosError = error as AxiosError;
            toast({
                title: "Wage Import Job was not deleted",
                description: `[${axiosError.request.status ?? "ERR"}]: ${axiosError.message}`,
                status: "error",
                isClosable: true,
                duration: null,
            });
        },
    });
}
